// @lobstrco/signer-extension-api/build/@shared/constants/services
export const LOBSTR_CONNECTION_KEY = 'LOBSTR_CONNECTION_KEY';
